// extracted by mini-css-extract-plugin
module.exports = {"container":"jut__Container__container","fluid":"jut__Container__fluid"};